import React from "react";
import { GREY_5 } from "consts/colors";
import Col from "core/Col";

const Divider = () => <Col backgroundColor={GREY_5} height={1} widht="100%" borderRadius={0.5} />;

export default Divider;
